import { useState } from "react";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import AmbassadorMessage from "@/components/AmbassadorMessage";
import ProgramsGrid from "@/components/ProgramsGrid";
import WhyChooseUs from "@/components/WhyChooseUs";
import Memberships from "@/components/Memberships";
import Franchise from "@/components/Franchise";
import VideoDialog from "@/components/VideoDialog";

export default function Home() {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <main data-testid="home-page" className="bg-[#f7f2e8]">
      <Hero />
      <TrustStrip />
      <AmbassadorMessage onWatchClick={() => setVideoOpen(true)} />
      <ProgramsGrid />
      <WhyChooseUs />
      <Memberships />
      <Franchise />
      <VideoDialog open={videoOpen} onOpenChange={setVideoOpen} />
    </main>
  );
}
